export default 'buildingsApp';
